import React from 'react'
import { Link } from 'react-router-dom'

import Weather from './Weather'
import Logo from 'core/components/Logo'

const Header = props => {
  const classList =
    location.pathname === '/' ? 'header mod-home type-body mod-ui' : 'header type-body mod-ui'

  const defaultQuery = 'lat=43.700111&lon=-79.416298' // Toronto.

  return (
    <header className={classList}>
      <div className="header-branding">
        <Link className="header-branding-link" to="/">
          <h1 className="u-screen-reader-text">Partisans</h1>
          <span className="header-branding-logo">
            <Logo />
          </span>{' '}
          <h2 className="header-branding-tagline type-body mod-ui">Don't hire us — join us</h2>
        </Link>
      </div>
      <div className="header-info">
        <Weather query={defaultQuery} />
      </div>
    </header>
  )
}

export default Header
